import React, { useRef, useState } from 'react';
import Modal from '../common/Modal';

const LS_KEY = 'accepted_code_of_conduct_v1';

function defaultText(){
  return `Be respectful. No abusive, harassing, hateful, or threatening language. Do not share private information or encourage illegal activity. Do not spam, solicit, or advertise.\n\nVoice and chat are public to room participants. Keep language appropriate for all ages. \n\nBy accepting, you agree to follow these rules. This is a lightweight, in-app code of conduct intended to keep the environment safe and welcoming.`;
}

export default function CodeOfConductModal({ show, onClose, onAccept }){
  const textRef = useRef(null);
  // Ignore scrolling — Accept is always available
  const [canAccept] = useState(true);
  const [text] = useState(defaultText());
  // No scroll checks: Accept remains enabled regardless of scroll position

  const handleAccept = () => {
    try{ localStorage.setItem(LS_KEY, Date.now().toString()); }catch(e){}
    onAccept && onAccept();
    onClose && onClose();
  };

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Modal show={!!show} title="Code of Conduct" onClose={handleClose}>
      <div className="p-4">
        <div ref={textRef} className="mb-4 bg-white dark:bg-gray-800 text-m max-h-[48vh] overflow-y-auto whitespace-pre-line">
          {text}
          {"\n\n"}
          {"Only press the Accept button if you agree to follow the Code of Conduct."}
        </div>
        <div className="flex justify-end gap-2">
          <button className="px-3 py-1 rounded bg-gray-300 dark:bg-gray-700" onClick={handleClose}>Close</button>
          <button className={`px-3 py-1 rounded font-semibold bg-green-600 text-white`} onClick={handleAccept}>Accept</button>
        </div>
      </div>
    </Modal>
  );
}

export function hasAcceptedCodeOfConduct(){
  try{ return !!localStorage.getItem(LS_KEY); }catch(e){ return false; }
}
